'use client';

import { useCallback, useEffect, useState } from 'react';

import { ARTICLE_BANNER_SCROLL_PX } from '../consts';

type UseArticleBannerVisibilityResult = {
  isVisible: boolean;
  dismiss: () => void;
};

export const useArticleBannerVisibility = (): UseArticleBannerVisibilityResult => {
  const [isDismissed, setIsDismissed] = useState(false);
  const [hasPassedScrollThreshold, setHasPassedScrollThreshold] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= ARTICLE_BANNER_SCROLL_PX) {
        setHasPassedScrollThreshold(true);
      }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const dismiss = useCallback(() => {
    setIsDismissed(true);
  }, []);

  return {
    isVisible: hasPassedScrollThreshold && !isDismissed,
    dismiss,
  };
};
